import React from 'react';
import { UserInfoProvider } from './contexts/userInfo.context';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { IntroSection } from './components/IntroSection';
import { LoginSection } from './components/LoginSection';
import { SymptomSection } from './components/SymptomSection';
import { ContactSection } from './components/contact/ContactSection';
import { StatisticSection } from './components/statistic/StatisticSection';
import { Card, Grid, CssBaseline, Box, createMuiTheme, ThemeProvider } from '@material-ui/core';
import { BrowserRouter } from 'react-router-dom';
import { LocalizedRouter, appStrings } from './i18n';
import { Color } from './constants';

export const App: React.FC = () => {
  const sections = [
    <IntroSection />,
    <LoginSection />,
    <SymptomSection />,
    <ContactSection />,
    <StatisticSection />,
  ];

  const theme = createMuiTheme({
    palette: {
      primary: { main: Color.ThemePrimary },
    },
  });

  return (
    <LocalizedRouter RouterComponent={BrowserRouter} appStrings={appStrings}>
      <UserInfoProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Grid container justify="center">
            <Grid
              item
              xs={12}
              sm={8}
              md={8}
              style={{ paddingLeft: theme.spacing(1), paddingRight: theme.spacing(1) }}
            >
              <Header />
              <Box pb={2} />
              {sections.map((section, index) => (
                <Card
                  key={index}
                  style={{
                    paddingTop: theme.spacing(5),
                    paddingBottom: theme.spacing(5),
                    paddingLeft: '6%',
                    paddingRight: '6%',
                    marginTop: theme.spacing(0),
                    marginBottom: theme.spacing(2),
                  }}
                >
                  {section}
                </Card>
              ))}
              <Footer />
            </Grid>
          </Grid>
        </ThemeProvider>
      </UserInfoProvider>
    </LocalizedRouter>
  );
};
